var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3465 9.99798H13.4012L14.7045 4.85336H16.8406L14.6908 13.0585H12.3305L10.963 7.87559H10.911L9.54347 13.0585H7.21869L5.07031 4.85336H7.2898L8.59305 9.99798H8.64364L9.99886 4.85336H11.9913L13.3465 9.99798Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.922 31.922H0V0H31.922V31.922ZM2.43692 29.4851H29.4851V2.43692H2.43692V29.4851Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8032 27.2724V20.8902H17.9902V19.0673H25.8562V20.8902H23.0036V27.2724H20.8032Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7039 14.7433H1.21875V17.1802H30.7039V14.7433Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.c083cbdb31644dd45cba1ba5a525bf10.svg";
export { ForwardRef as ReactComponent };